<template>
  <div ref="zmrMenuRef" class="zmr-menu">
    <template v-for="(item,index) in props.data">
      <div v-if="item.children !== undefined && item.children.length > 0 && !props.isCollapse" :key="index" class="zmr-sub-menu">
        <div class="zmr-sub-menu-title" :class="activeItem.id === item.id?'active':''" @click="menuItemSetStatus(item,index)">
          <div class="zmr-sub-menu-title-icon" v-if="item.icon !== undefined && item.icon !== ''">
            <zlIcon :name="item.icon"></zlIcon>
          </div>
          <div>{{ item[itemProps.title] }}</div>
          <div class="zmr-sub-menu-title-arrow">
            <i class="iconfont zmr_icon_i icon-jinru" v-if="openIndex.indexOf(index) < 0"></i>
            <i class="iconfont zmr_icon_i icon-zhankai" v-if="openIndex.indexOf(index) >= 0"></i>
          </div>
        </div>
        <div v-show="openIndex.indexOf(index) >= 0">
          <subZmrMenu
              :class="openIndex.indexOf(index) >= 0?'zmr-sub-menu-open':''"
              ref="zmrMenuChildrenRef"
              :data="item.children"
              :isCollapse="props.isCollapse"
              :defaultActive="itemDefaultValue"
              :uniqueOpened="props.uniqueOpened"
              :router="props.router"
              :menuProps="props.menuProps"
              :bgColor="props.bgColor"
              :textColor="props.textColor"
              :activeBgColor="props.activeBgColor"
              :activeColor="props.activeColor"
              :hoverBgColor="props.hoverBgColor"
              :hoverColor="props.hoverColor"
              :isBackParent="props.isBackParent"
              :parentIndex="Number(index)"
              :level="menuLevel"
              @menuClick="menuClickFun"
              @open="menuOpen"
              @close="menuClose"

          ></subZmrMenu>
        </div>
      </div>
      <div @click="menuItemClick(item,index)" v-if="(item.children === undefined || item.children.length <= 0) && !props.isCollapse"
           :key="index" class="zmr-menu-item" :class="activeItem.id === item.id?'active':''">
        <div class="zmr-menu-item-icon" v-if="item.icon !== undefined && item.icon !== ''">
          <zlIcon :name="item.icon"></zlIcon>
        </div>
        <div class="zmr-menu-item-title">{{ item[itemProps.title] }}</div>
      </div>
      <div @mouseenter="mouseenterMenuItemFun(index,$event,item)" @mouseleave="mouseleaveMenuItemFun" @click="menuItemClick(item,index)" class="zmr-popover-menu" :class="activeItem.id === item.id?'active':''" v-if="props.isCollapse" :key="index">
        <div class="zmr-menu-collapse-div" :class="activeItem.id === item.id?'active':''">
          <div class="zmr-menu-collapse-div-icon" v-if="item.icon !== undefined && item.icon !== ''">
            <zlIcon :name="item.icon"></zlIcon>
          </div>
          <div v-if="item.icon === undefined || item.icon === ''" style="text-align: center">
            {{ item[itemProps.title].substring(0, 1) }}
          </div>
        </div>
        <div class="zmr-popover-menu-content" :style="{top:popoverTop}" v-show="openIndex.indexOf(index) >= 0">
          <div class="zmr-popover-menu-content-text">{{ item.name }}</div>
        </div>
      </div>
      <div @mouseenter="mouseenterMenuItemFun(index,$event,item)" @mouseleave="mouseleaveMenuItemFun" class="zmr-popover-menu" :key="index" v-if="props.isCollapse && item.children !== undefined && item.children.length > 0">
        <div class="zmr-menu-collapse-div">
          <div class="zmr-menu-collapse-div-icon" v-if="item.icon !== undefined && item.icon !== ''">
            <zlIcon :name="item.icon"></zlIcon>
          </div>
          <div v-if="item.icon === undefined || item.icon === ''" style="text-align: center">
            {{ item[itemProps.title].substring(0, 1) }}
          </div>
        </div>
        <popoverZmrMenu
            ref="zmrMenuChildrenRef"
            class="zmr-popover-menu-content"
            v-show="openIndex.indexOf(index) >= 0"
            :style="{top:popoverTop}"
            :iconTop="iconTop"
            :data="item.children"
            :defaultActive="itemDefaultValue"
            :router="props.router"
            :menuProps="props.menuProps"
            :bgColor="props.bgColor"
            :textColor="props.textColor"
            :activeBgColor="props.activeBgColor"
            :activeColor="props.activeColor"
            :hoverBgColor="props.hoverBgColor"
            :hoverColor="props.hoverColor"
            :isBackParent="props.isBackParent"
            :parentIndex="Number(index)"
            :parentItem="item"
            @hide="popoverHide"
            @show="popoverShow"
            @menuClick="menuClickFun"
        ></popoverZmrMenu>
      </div>
    </template>
  </div>
</template>

<script setup>
import zlIcon from '../base/zl-icon.vue'
import subZmrMenu from './zmr_menu.vue'
import popoverZmrMenu from './popover_zmr_menu.vue'
import {ref, onMounted, watch,computed} from 'vue'
import {useRouter} from 'vue-router'
import {useStore} from 'vuex'
import {isNotEmpty} from "../../common/js/comjs";

const store = useStore();
const router = useRouter();
const props = defineProps({
  data: {
    type: Array,
    default: new Array([])
  },
  isCollapse: {
    type: Boolean,
    default: false
  },
  defaultActive: {
    default: ''
  },
  uniqueOpened: {
    type: Boolean,
    default: false
  },
  router: {
    type: Boolean,
    default: false
  },
  menuProps: {
    type: Object,
    default: new Object({})
  },
  level: {
    type: Number,
    default: 0
  },
  bgColor: {
    type: String,
    default: ''
  },
  textColor: {
    type: String,
    default: ''
  },
  activeBgColor: {
    type: String,
    default: ''
  },
  activeColor: {
    type: String,
    default: ''
  },
  hoverBgColor: {
    type: String,
    default: ''
  },
  hoverColor: {
    type: String,
    default: ''
  },
  isBackParent: {
    type: Boolean,
    default: false
  },
  parentIndex: {
    type: Number
  },
});
const emit = defineEmits(['menuClick', 'open', 'close']);
const openIndex = ref([]);
const activeItem = ref({});
const activeItemId = ref('');
const activeIndex = ref(-1);
const menuLevel = props.level + 1;
const zmrMenuRef = ref(null);
const zmrMenuChildrenRef = ref(null);
const iconTop = ref(0);
const timeIndex = ref(null);
const itemProps = ref({
  id: 'id',
  title: 'name',
  path: 'path',
  icon: 'icon'
});
const popoverTop = ref(0);
const itemDefaultValue = ref('');
if (props.defaultActive !== '') {
  itemDefaultValue.value = computed(()=>{
    return props.defaultActive;
  });
}

if (JSON.stringify(props.menuProps) !== '{}') {
  let menuProps = computed(()=>{
    return props.menuProps;
  })
  for (let i in menuProps) {
    if (itemProps.value[i] !== undefined &&menuProps[i] !== null &&menuProps[i] !== '') {
      itemProps.value[i] =menuProps[i];
    }
  }
}

watch(() => props.data, () => {
  if (timeIndex.value !== null) {
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }
}, {deep: true})

watch(() => props.isCollapse, (newData, oldData) => {
  if (timeIndex.value !== null) {
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }
  if (newData !== oldData) {
    itemDefaultValue.value = String(activeItemId.value);
    setDefaultActive(activeItemId.value);
  }
  if (newData) {
    iconTop.value = 0;
    openIndex.value = [];
  }
}, {deep: true})

watch(() => props.defaultActive, (newData, oldData) => {
  if (timeIndex.value !== null) {
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }

  if (newData !== oldData) {
    activeItemId.value = newData;
    itemDefaultValue.value = String(activeItemId.value);
    setDefaultActive(activeItemId.value);
  }
  if (newData) {
    openIndex.value = [];
  }
}, {deep: true})

watch(()=>store.state.activeMenuId,(newData,oldData)=>{
  if(newData !== oldData && newData !== activeItem.value.id){
    activeItem.value = {};
    activeIndex.value = -1;
  }
})

onMounted(() => {

  setDefaultActive(props.defaultActive);

  zmrMenuRef.value.style.setProperty('--zl-menu-level', menuLevel);

  if (props.bgColor !== '') {
    document.documentElement.style.setProperty('--zl-menu-bg-color', props.bgColor);
  }
  if (props.textColor) {
    document.documentElement.style.setProperty('--zl-menu-text-color', props.textColor);
  }
  if (props.activeColor) {
    document.documentElement.style.setProperty('--zl-menu-active-color', props.activeColor);
  }
  if (props.activeBgColor) {
    document.documentElement.style.setProperty('--zl-menu-active-bg-color', props.activeBgColor);
  }
  if (props.hoverColor) {
    document.documentElement.style.setProperty('--zl-menu-hover-color', props.hoverColor);
  }
  if (props.hoverBgColor) {
    document.documentElement.style.setProperty('--zl-menu-hover-bg-color', props.hoverBgColor);
  }
})
//鼠标移入菜单节点
const mouseenterMenuItemFun = (index, event, data) => {
  //计算定位显示的位置
  let top = event.clientY - event.offsetY;
  let winHeight = window.innerHeight;
  let domHeight = (data.children.length * 47.125) + 43;
  if ((top + domHeight) < winHeight || data.children.length === 0) {
    popoverTop.value = top + 'px';
    iconTop.value = 'calc(var(--zl-menu-padding) + 2px)';
  } else {
    popoverTop.value = (winHeight - domHeight - 10) + 'px';
    let iTop = top - (winHeight - domHeight - 30);
    iconTop.value = iTop + 'px';
  }
  if (timeIndex.value !== null) {
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }
  openIndex.value = [index];
}
//鼠标移除菜单节点
const mouseleaveMenuItemFun = () => {
  if (timeIndex.value !== null) {
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }
  timeIndex.value = setInterval(() => {
    openIndex.value = [];
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }, 200)
}

//设置默认选中
const setDefaultActive = (activeData) => {
  if (isNotEmpty(activeData)) {
    for (let i in props.data) {
      let dataItem = props.data[i];
      if (isNotEmpty(dataItem[itemProps.value.id]) && String(dataItem[itemProps.value.id]) === activeData) {
        activeIndex.value = i;
        activeItem.value = dataItem;
        if (!props.isCollapse) {
          emit('open', dataItem, props.parentIndex)
        }
        break;
      }
    }
  }
}

//气泡框隐藏
const popoverHide = () => {
  if (timeIndex.value !== null) {
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }
  openIndex.value = [];
}
//气泡框显示
const popoverShow = () => {
  if (timeIndex.value !== null) {
    clearInterval(timeIndex.value);
    timeIndex.value = null;
  }
}

//菜单点击
const menuItemClick = (item, index) => {
  if(Number(index) === Number(activeIndex.value)){
    return;
  }
  activeItem.value = item;
  activeIndex.value = index;
  activeItemId.value = item[itemProps.value.id];
  if (props.router) {
    if (item[itemProps.value.path] !== undefined && item[itemProps.value.path] !== null && item[itemProps.value.path] !== '') {
      //设置页面的按钮权限
      if (isNotEmpty(item.children) && item.children.length > 0) {
        let rank = [];
        for (let i in item.children) {
          let iData = item.children[i];
          if (iData.menuType === 'action' && isNotEmpty(iData.code)) {
            rank.push(iData.code);
          }
        }
        store.commit('setPageRank', rank);
      }
      //设置选中的菜单s
      store.commit('commitSetMenu', item);
      //页面跳转
      let routerPath = "";
      if(item[itemProps.value.path].indexOf('/') !== 0){
        routerPath = '/'+item[itemProps.value.path];
      }else {
        routerPath = item[itemProps.value.path];
      }
      router.push({
        path: routerPath
      });
    }
  }
  clearActive();
  if (props.isBackParent) {
    emit('menuClick', [item], props.parentIndex);
  } else {
    emit('menuClick', item, props.parentIndex);
  }
}

//设置菜单状态
const menuItemSetStatus = (item, index) => {
  /*if (item.menuType === 'link' && isNotEmpty(item.path)) {
    menuItemClick(item, index);
    return;
  }*/

  let openIndexKey = openIndex.value.indexOf(index);
  if (openIndexKey >= 0) { //关闭展示
    openIndex.value.splice(openIndexKey, 1);
    emit('close', item, index);
  } else {
    if (props.uniqueOpened) {
      openIndex.value = [index];
      clearChildrenOpen(false);
    } else {
      openIndex.value.push(index);
    }
    emit('open', item, props.parentIndex);
  }
}

//监听子集点击返回
const menuClickFun = (data, parentIndex = '') => {
  if (Array.isArray(data)) {
    activeItemId.value = data[data.length - 1][itemProps.value.id];
  } else {
    activeItemId.value = data[itemProps.value.id];
  }
  activeItem.value = {};
  activeIndex.value = -1;
  if (props.isBackParent) {
    let returnData = data;
    if (openIndex.value.length === 1) {
      if (isNotEmpty(props.data[openIndex.value[0]])) {
        let parentData = JSON.parse(JSON.stringify(props.data[openIndex.value[0]]));
        if (isNotEmpty(parentData.children)) {
          parentData.children = [];
          returnData.unshift(parentData)
        }
      }
    } else {
      if (isNotEmpty(parentIndex)) {
        let parentData = JSON.parse(JSON.stringify(props.data[parentIndex]));
        if (isNotEmpty(parentData.children)) {
          parentData.children = [];
          returnData.unshift(parentData)
        }
      }
    }
    clearActive(true, parentIndex);
    emit('menuClick', returnData, props.parentIndex);
  } else {
    clearActive(true, parentIndex);
    emit('menuClick', data, props.parentIndex);
  }
}
//监听只节点展开
const menuOpen = (data, parentIndex) => {
  if (parentIndex !== undefined && parentIndex !== null && parentIndex !== '') {
    if (openIndex.value.indexOf(parentIndex) < 0) {
      openIndex.value.push(parentIndex);
    }
  }
  emit('open', data, props.parentIndex);
}
//监听只节点关闭
const menuClose = (data) => {
  emit('close', data);
}

//从父级清除子集的选中
const clearActive = (isClear, removeIndex = '') => {
  if (isClear !== undefined && isClear) {
    activeItem.value = {};
    activeIndex.value = -1;
  }
  if (zmrMenuChildrenRef.value !== null) {
    for (let i in zmrMenuChildrenRef.value) {
      if (isNotEmpty(removeIndex) && Number(i) === Number(removeIndex)) {
        continue;
      }
      zmrMenuChildrenRef.value[i].clearActive(true, '');
    }
  }
}

//从父级关闭子集的展开
const clearChildrenOpen = (isOpen) => {
  if (isNotEmpty(isOpen) && isOpen) {
    openIndex.value = [];
  }
  if (zmrMenuChildrenRef.value !== null) {
    if (openIndex.value.length > 0) {
      for (let i in zmrMenuChildrenRef.value) {
        zmrMenuChildrenRef.value[i].clearChildrenOpen(true);
      }
    }
  }
}

defineExpose({clearActive, clearChildrenOpen})

</script>

<style scoped lang="less">
.zmr-menu {
  --zl-menu-level: 1;
  background-color: var(--zl-menu-bg-color);
  font-size: 14px;
  .zmr-menu-collapse-div {
    padding-left: var(--zl-menu-padding);
    padding-right: 5px;
    padding-top: calc(var(--zl-menu-padding) - 3px);
    padding-bottom: calc(var(--zl-menu-padding) - 3px);
    color: var(--zl-menu-text-color);
    cursor: pointer;
    margin: 5px 0;

    .zmr-menu-collapse-div-icon {
      font-size: 18px;
      margin: auto;
    }
  }

  .zmr-menu-collapse-div:hover {
    background-color: var(--zl-menu-active-bg-color);
    color: var(--zl-menu-active-color);
  }

  .zmr-menu-item {
    cursor: pointer;
    color: var(--zl-menu-text-color);
    padding-left: calc(var(--zl-menu-padding) * var(--zl-menu-level));
    padding-right: 5px;
    padding-top: calc(var(--zl-menu-padding) - 3px);
    padding-bottom: calc(var(--zl-menu-padding) - 3px);
    display: flex;
    align-items: center;
    margin: 5px 0;

    .zmr-menu-item-icon {
      width: 14px;
      height: 14px;
      font-size: 14px;
      margin-right: 8px;

      img {
        width: 100%;
        height: 15px;
      }
    }

    .zmr-menu-item-title {

    }
  }

  .active {
    position: relative;
    background-color: var(--zl-menu-active-bg-color);
    color: var(--zl-menu-active-color);
    font-weight: 600;
  }

  .active::before {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 2px;
    background-color: var(--zl-menu-active-line-bg-color);
    content: '';
    display: inline-block;
  }

  .zmr-menu-item:hover {
    background-color: var(--zl-menu-hover-bg-color);
    color: var(--zl-menu-hover-color);
  }

  .zmr-sub-menu {
    margin: 5px 0;

    .zmr-sub-menu-title {
      cursor: pointer;
      padding-top: calc(var(--zl-menu-padding) - 3px);
      padding-bottom: calc(var(--zl-menu-padding) - 3px);
      color: var(--zl-menu-text-color);
      display: flex;
      padding-left: calc(var(--zl-menu-padding) * var(--zl-menu-level));
      padding-right: var(--zl-menu-padding);
      align-items: center;
      position: relative;

      .zmr-sub-menu-title-icon {
        width: 14px;
        height: 14px;
        font-size: 14px;
        margin-right: 8px;

        img {
          width: 100%;
          height: 15px;
        }
      }

      .zmr-sub-menu-title-arrow {
        position: absolute;
        right: 5px;
        top: calc(50% - 6px);
        color: var(--zl-menu-text-color);
        font-size: 12px;
        width: 12px;
        height: 12px;
        line-height: 12px;
      }
    }

    .zmr-sub-menu-title:hover {
      background-color: var(--zl-menu-hover-bg-color);
      color: var(--zl-menu-hover-color);
    }
  }

  .zmr-sub-menu-open {
    background-color: var(--zl-menu-open-bg-color);
  }

  .zmr-popover-menu {
    position: relative;

    .zmr-popover-menu-content {
      position: fixed;
      top: 0;
      left: 60px;
      z-index: 2222;
      filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3));
      border-radius: 4px;

      .zmr-popover-menu-content-text {
        min-width: 100px;
        width: max-content;
        background-color: var(--zl-menu-bg-color);
        color: var(--zl-menu-text-color);
        padding: var(--zl-menu-padding);
        border-radius: 4px;
        position: relative;
      }

      .zmr-popover-menu-content-text::before {
        position: absolute;
        background-color: var(--zl-menu-bg-color);
        width: 10px;
        height: 10px;
        top: calc(50% - 5px);
        left: -4px;
        border-radius: 2px;
        content: '';
        display: inline-block;
        transform: rotate(45deg);
      }
    }
  }
}
</style>
